import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiResponse } from '@nf/types/api';
import { WcPromotionSpinDrawRequest, WcPromotionSpinDrawResponse } from './types';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useApiBackendInfo } from '@/hooks/query/use-api-backend-info';
import queryKeys from '@/constants/query-keys';
import { useAccountInfo } from '@/hooks/query/account';

export const useWcPromotionSpinDraw = () => {
	const queryClient = useQueryClient();
	const apiBackendInfo = useApiBackendInfo();
	const { user } = useAccountInfo();

	return useMutation({
		mutationFn: async (): Promise<ApiResponse<WcPromotionSpinDrawResponse>> => {
			const userId = user?.ID;
			if (userId == null) {
				throw new Error('Spin draw: user ID is not available');
			}
			const body: WcPromotionSpinDrawRequest = { userId };
			const response = await fetchComposer.postWithBearer(`${apiBackendInfo.url}/spin/draw`, {
				body: JSON.stringify(body)
			})(apiBackendInfo.token);
			if (!response.ok) {
				throw new Error(`${response.status}: ${response.statusText}`);
			}
			return await response.json();

		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [queryKeys.WC_PROMOTION_SPIN_DAILY_INFO] });
			queryClient.invalidateQueries({ queryKey: [queryKeys.WC_PROMOTION_SPIN_HISTORY] });
		}
	});
};
